import Styled, { css } from 'styled-components';
import merge from 'lodash/merge';

import {
  cssDeclaration,
  VALID_EDGE_STYLE_DATA,
  VALID_MEDIA_STYLES
} from '../../Utils';
import { VALID_GLOBAL_FONT_SIZES } from '../common';
import { FONT_MAP } from '../../../../lib/StyledComponents';

import { IHeadingCommonProps, IHeadingDefaultStyles } from './common';

interface IStyledHeadingProps extends IHeadingCommonProps {
  marginProp?: VALID_EDGE_STYLE_DATA;
  orderProp?: VALID_MEDIA_STYLES;
}

export const StyledHeading = Styled.h1<IStyledHeadingProps>`
  ${({
    theme: { themeTwo },
    align,
    alignSelf,
    flexBasis,
    flexGrow,
    flexShrink,
    level,
    marginProp,
    orderProp,
  }) => {
    const headingDefault = themeTwo.heading.default;
    const headingLevel = themeTwo.heading.level[level];
    const levelStyles: IHeadingDefaultStyles = merge({}, headingDefault, headingLevel);

    return css`
      /*
        zeros global heading margin set by src/lib/StyledComponents/globalStyleCommon.ts
        this can be removed once the global css is restructured
      */
      margin: 0;
      font-family: ${levelStyles.family && FONT_MAP[levelStyles.family]};
      font-weight: ${levelStyles.weight};

      /* line-height */ ${cssDeclaration(themeTwo, 'line-height', levelStyles.lineHeight)};
      /* color */ ${cssDeclaration(themeTwo, 'color', levelStyles.color)};
      /* margin */ ${cssDeclaration(themeTwo, 'margin', marginProp)};
      /* align-self */ ${alignSelf && cssDeclaration(themeTwo, 'align-self', alignSelf)};
      /* flex-basis */ ${flexBasis && cssDeclaration(themeTwo, 'flex-basis', flexBasis)};
      /* flex-grow */ ${flexGrow && cssDeclaration(themeTwo, 'flex-grow', flexGrow)};
      /* flex-shrink */ ${flexShrink && cssDeclaration(themeTwo, 'flex-shrink', flexShrink)};
      /* order */ ${orderProp && cssDeclaration(themeTwo, 'order', orderProp)};
      /* text-align */ ${align && cssDeclaration(themeTwo, 'text-align', align)};
      /* font-size */ ${levelStyles.size && cssDeclaration(themeTwo, 'font-size', levelStyles.size as VALID_GLOBAL_FONT_SIZES)};
    `;
  }}
`;
